import React, { useState } from "react";
import { Alert, Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import { Print, QrCode2, Save } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  getLabelPrinterSettings,
  printMedicineLabel,
  setLabelPrinterSettings,
} from "../../../../Components/BarcodeScanner/printMedicineLabel";

const LabelPrintSettings = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(getLabelPrinterSettings);

  const updateSetting = (key) => (event) => {
    setSettings((current) => ({ ...current, [key]: event.target.value }));
  };

  const saveSettings = () => {
    const saved = setLabelPrinterSettings(settings);
    setSettings(saved);
    toast.success(t("pharmacy.labelSettingsSaved"));
    return saved;
  };

  const printTestLabel = async (mode) => {
    saveSettings();
    const opened = await printMedicineLabel({
      barcode: "PHARMACY-LABEL-TEST",
      name: "Test label",
      mode,
      copies: 1,
    });
    if (!opened) toast.error(t("pharmacy.printBlocked"));
  };

  const fields = [
    ["widthMm", "labelWidth", "labelWidthHelp", 20, 80, 1],
    ["heightMm", "labelHeight", "labelHeightHelp", 15, 120, 1],
    ["qrSizeMm", "qrSize", "qrSizeHelp", 5, 75, 1],
    ["topMarginMm", "labelTopMargin", null, 0, 20, 0.5],
    ["bottomMarginMm", "labelBottomMargin", null, 0, 20, 0.5],
    ["leftMarginMm", "labelLeftMargin", null, 0, 20, 0.5],
    ["rightMarginMm", "labelRightMargin", null, 0, 20, 0.5],
    ["copies", "labelCopies", "labelCopiesHelp", 1, 100, 1],
  ];

  return (
    <Grid container maxWidth="md" sx={{ mt: 2, mb: 4 }}>
      <Paper sx={{ width: "100%", p: { xs: 2, md: 4 }, borderRadius: 3 }}>
        <Typography variant="h4" fontWeight={700} color="primary" mb={1}>
          {t("pharmacy.labelPrintSettings")}
        </Typography>
        <Typography color="text.secondary" mb={3}>
          {t("pharmacy.labelSettingsDescription")}
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          {t("pharmacy.labelGapDriverHelp")}
        </Alert>
        <Box component="form" onSubmit={(event) => { event.preventDefault(); saveSettings(); }}>
          <Grid container spacing={2}>
            {fields.map(([key, label, help, min, max, step]) => (
              <Grid item xs={12} sm={6} md={4} key={key}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  label={t(`pharmacy.${label}`)}
                  value={settings[key]}
                  onChange={updateSetting(key)}
                  helperText={help ? t(`pharmacy.${help}`) : " "}
                  inputProps={{ min, max, step }}
                />
              </Grid>
            ))}
          </Grid>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} mt={3}>
            <Button type="submit" variant="contained" startIcon={<Save />}>
              {t("pharmacy.saveLabelSettings")}
            </Button>
            <Button variant="outlined" startIcon={<Print />} onClick={() => printTestLabel("barcode")}>
              {t("pharmacy.printTestBarcode")}
            </Button>
            <Button variant="outlined" startIcon={<QrCode2 />} onClick={() => printTestLabel("qr")}>
              {t("pharmacy.printTestQr")}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Grid>
  );
};

export default LabelPrintSettings;
